import EventBusV3 from '~/EventBusV3'

import store from '~/store'

export default async (to, from, next) => {
  if (store.getters['auth/check']) {
    let user = store.getters['auth/user']

    if (user.role_id !== 1 && user.role_id !== 5) {
      if (user.needs_to_complete_registration) {
        setTimeout(function () {
          EventBusV3.emit('account:complete-registration', { canClose: false })
        }, 0)
      }
    }
  }

  next()
}
